(() => {
  "use strict";

  const currentScript = document.currentScript;
  if (!currentScript?.src) return;

  const coreUrl = new URL(currentScript.src, window.location.href);
  coreUrl.pathname = coreUrl.pathname.replace(
    /ftr-cart-drawer-fixes\.js$/,
    "ftr-cart-drawer-fixes-core.js",
  );
  coreUrl.search = "";

  function normalizeText(value) {
    return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
  }

  function isRouteProtectionCard(card) {
    const title = normalizeText(
      card.querySelector(".ftr-addon-card__title")?.textContent,
    );
    return (
      title.includes("shipping protection") && title.includes("route")
    ) || title === "route" || title === "route shipping protection";
  }

  function cleanPriceMarkup(priceElement) {
    if (!priceElement) return;
    const text = String(priceElement.textContent || "").trim();
    if (!/<\/?span\b/i.test(text)) return;

    const template = document.createElement("template");
    template.innerHTML = text;
    const parsedText = String(template.content.textContent || "").trim();
    if (parsedText) priceElement.textContent = parsedText;
  }

  function sanitizeRecommendations(root = document) {
    root.querySelectorAll?.("#ftr-cart-drawer .ftr-addon-card").forEach((card) => {
      if (isRouteProtectionCard(card)) card.remove();
    });

    root
      .querySelectorAll?.("#ftr-cart-drawer .ftr-addon-card__price")
      .forEach(cleanPriceMarkup);

    root.querySelectorAll?.("#ftr-cart-drawer .ftr-addons").forEach((section) => {
      if (!section.querySelector(".ftr-addon-card")) section.remove();
    });
  }

  const patchObserver = new MutationObserver(() => sanitizeRecommendations());

  function installPatch() {
    sanitizeRecommendations();
    const drawer = document.getElementById("ftr-cart-drawer");
    if (drawer && drawer.dataset.ftrRecommendationSanitizer !== "true") {
      drawer.dataset.ftrRecommendationSanitizer = "true";
      patchObserver.observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  const core = document.createElement("script");
  core.src = coreUrl.toString();
  core.defer = true;
  core.onload = installPatch;
  core.onerror = () => console.error("[FTR Cart Fixes] Unable to load cart fixes core.");
  currentScript.parentNode.insertBefore(core, currentScript.nextSibling);

  // Install immediately too, so the server-rendered recommendation cards are
  // cleaned before/while the existing recommendation enhancement initializes.
  installPatch();
})();
